import { render, staticRenderFns } from "./refresh-activities-popup.component.vue?vue&type=template&id=052db404&scoped=true&"
import script from "./refresh-activities-popup.component.vue?vue&type=script&lang=js&"
export * from "./refresh-activities-popup.component.vue?vue&type=script&lang=js&"
import style0 from "./refresh-activities-popup.component.vue?vue&type=style&index=0&id=052db404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052db404",
  null
  
)

export default component.exports